import { useContext } from 'react';
import { AudioServicesContext } from './audio-services-context';

/**
 * Hook para consumir AudioServicesValue desde cualquier componente interno
 * del editor (sound panel, futuras integraciones).
 *
 * Tira error explícito si nadie wrappeó el editor con <AudioServicesProvider>.
 * Eso evita silently-no-op y deja claro al dev qué falta.
 */
export const useAudioServices = () => {
  const ctx = useContext(AudioServicesContext);
  if (!ctx) {
    throw new Error(
      '[creativity-editor] useAudioServices() must be used inside <AudioServicesProvider>. ' +
        'Wrap your <CreativityEditor> with it from the consumer app to enable audio features.'
    );
  }
  return ctx;
};
